import {Permission, UserEffectivePermissions} from '../models/permission.model';

// API Response DTO interface
export interface PermissionDTO {
  id: number;
  name: string;
  resource: string;
  action: string;
  description?: string;
  created_at: string;
  updated_at: string;
  deleted_at?: string;
}

// API Response wrapper
export interface PermissionsListResponseDTO {
  permissions: PermissionDTO[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    pages: number;
  };
}

// DTO to Model Mappers
export const mapPermissionDTOToModel = (dto: PermissionDTO): Permission => {
  return {
    id: dto.id,
    name: dto.name,
    resource: dto.resource,
    action: dto.action,
    description: dto.description,
    createdAt: dto.created_at,
    updatedAt: dto.updated_at
  };
};

export const mapPermissionsListResponseToModel = (dto: PermissionsListResponseDTO): { permissions: Permission[]; pagination: any } => {
  return {
    permissions: dto.permissions.map(mapPermissionDTOToModel),
    pagination: dto.pagination
  };
};

// UserEffectivePermissions DTO interface
export interface UserEffectivePermissionsDTO {
  userId: number;
  rolePermissions: PermissionDTO[];
  userOverrides: {
    granted: PermissionDTO[];
    denied: PermissionDTO[];
  };
  effectivePermissions: PermissionDTO[];
}

export const mapUserEffectivePermissionsDTOToModel = (dto: UserEffectivePermissionsDTO): UserEffectivePermissions => {
  return {
    userId: dto.userId,
    rolePermissions: dto.rolePermissions.map(mapPermissionDTOToModel),
    userOverrides: {
      granted: dto.userOverrides.granted.map(mapPermissionDTOToModel),
      denied: dto.userOverrides.denied.map(mapPermissionDTOToModel)
    },
    effectivePermissions: dto.effectivePermissions.map(mapPermissionDTOToModel)
  };
};
